import snarkdown from '@bpmn-io/snarkdown';
import sanitizeHtml from '@commandbar/internal/util/sanitizeHtml';

export const parseMarkdown = (str: string) => {
  const parsed = snarkdown(str).replace(/(<a href="(https?:)?\/\/.*?")>/g, '$1 target="_blank" rel="nofollow">');

  return sanitizeHtml(parsed);
};
